let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eOyhI")).then(() => parcelRequire('k2dex'));